import SelectBloedLmwhHep from "../../../../src/components/content/SelectBloedLmwhHep";
import * as React from 'react';
export default {
  SelectBloedLmwhHep,
  React
};